// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-de2bf77c]:root{--white:#fff;--black:#222;--current-color:#1c59c6}.v-container[data-v-de2bf77c]{max-width:1130px;margin:0 auto;padding:0 18px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
